import Feature4_2 from './Feature4_2'
export default Feature4_2
